import { render, staticRenderFns } from "./ConfiguracionCia.vue?vue&type=template&id=2610a9f2&scoped=true"
import script from "./ConfiguracionCia.vue?vue&type=script&lang=js"
export * from "./ConfiguracionCia.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionCia.vue?vue&type=style&index=0&id=2610a9f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2610a9f2",
  null
  
)

export default component.exports